import { render, staticRenderFns } from "./widget-smc-event-list.vue?vue&type=template&id=0a78fb50"
import script from "./widget-smc-event-list.vue?vue&type=script&lang=ts"
export * from "./widget-smc-event-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports